module.exports = __webpack_public_path__ + "img/TJ.f3e6415e.svg";